import store from '@/store'
import commonFunctions from "@/commonFunctions";
let showSnackbar = false;
export const rulesValidations = {
    required : v => !!v || '' ,
    trim : v => !v || !!(v.toString()).trim() || showError("Field is required") || '',
    number : v => !v || checkNumber(v) || '',
    positiveNumber : v => !v || checkPositiveNumber(v)  || '',
    yearLength : v => !v || validYear(v) || '',
    nonZero : v => !v || nonZero(v)  || '',
    notContainsSpecialChars : v => !v || notContainsSpecialChars(v) || '',
    numberNotContainsSpecialChars : v => !v || numberNotContainsSpecialChars(v) || '' ,
    emojiNotAllowed : v => !v || checkForEmoji(v) || '',
    greaterThan : (compareWith,value,err) => {
      if(!isNaN(value) && !isNaN(compareWith)){
        if(parseFloat(value) > parseFloat(compareWith)){
          if(!showSnackbar){
            store.commit('ui/snackbar.reset')
          }
          return true
        }
        else{
          showError(err ? err : "Second number must be greater than the first number")
          return ''
        }
      }
      return true
    },
    lessThan : (compareWith,value,err) => {
      if(!isNaN(value) && !isNaN(compareWith)){
        if(parseFloat(value) < parseFloat(compareWith)){
          if(!showSnackbar){
            store.commit('ui/snackbar.reset')
          }
          return true
        }else{
          showError(err ? err : "First number must be less than the second number")
          return ''
        }
      }
      return true
    },
    lessThanEqualTo : (compareWith,value,err) => {
      if(!isNaN(value) && !isNaN(compareWith)){
        if(parseFloat(value) <= parseFloat(compareWith)){
          if(!showSnackbar){
            store.commit('ui/snackbar.reset')
          }
          return true
        }else{
          showError(err ? err : "First number must be less than or equal to the second number")
          return ''
        }
      }
      return true
    },
    greaterThanEqualTo : (compareWith,value,err) => {
      if(!isNaN(value) && !isNaN(compareWith)){
        if(parseFloat(value) >= parseFloat(compareWith)){
          if(!showSnackbar){
            store.commit('ui/snackbar.reset')
          }
          return true
        }else{
          showError(err ? err : "Second number must be greater than or equal the first number")
          return ''
        }
      }
      return true
    },
    numberLessThan : (compareWith,value,err) => {
      if(!isNaN(value) && !isNaN(compareWith)){
        if(parseFloat(value) <= compareWith){
          if(!showSnackbar){
            store.commit('ui/snackbar.reset')
          }
          return true
        }else{
          showError(err ? err : "Number must be less than "+compareWith)
          return ''
        }
      }
      return true
    },  
}

const notContainsSpecialChars= (v) => {
  const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  if(specialChars.test(v)){
    showError("Special characters are not allowed")
    return false
  }else{
    if(!showSnackbar){
      store.commit('ui/snackbar.reset')
    }
    return true;
  }
}

const numberNotContainsSpecialChars= (v) => {
  const specialChars = /[`!@#$%^&*()_+\=\[\]{};':"\\|,<>\/?~]/;
  if(specialChars.test(v)){
    showError("Special characters are not allowed")
    return false
  }else{
    if(!showSnackbar){
      store.commit('ui/snackbar.reset')
    }
    return true;
  }
}

const checkForEmoji = (value) =>{
  if(commonFunctions.isEmojiExist(value)){
    if(!showSnackbar){
      store.commit('ui/snackbar.reset')
    }
    return true;
  }
  else{
    showError("Emoji's are not allowed")
    return false;
  } 
}

const checkNumber = (value) => 
{
  if (isNaN(value)){
    showError("Enter Number only")
    return false;
  } 
  else {
    if(!showSnackbar){
      store.commit('ui/snackbar.reset')
    }
    return true
  }
}

const checkPositiveNumber = (value) => 
{
  if (isNaN(value) || value < 0) {
    showError("Please input a number that is equal to or greater than 1")
    return false;
  }
  else {
    if(!showSnackbar){
      store.commit('ui/snackbar.reset')
    }
    return true
  }
}

const validYear = (value) => 
{
  if (isNaN(value) || value.length != 4) {
    showError("Enter Valid Year")
    return false;
  }
  else {
    if(!showSnackbar){
      store.commit('ui/snackbar.reset')
    }
    return true
  }
}

const nonZero = (value) => 
{
  if (isNaN(value) || value == 0) {
    showError("Please input a number that is equal to or greater than 1") 
    return false;
  } 
  else {
    if(!showSnackbar){
      store.commit('ui/snackbar.reset')
    }
    return true
  }
   
}

const showError = (err)=> {
  if(!showSnackbar){
    showSnackbar = true;
    store.commit('ui/snackbar',{
      message : err,
      type: 'error'
    })
  }
  

  setTimeout(()=>{
    showSnackbar = false
  },1000)
  return false
}